import React from 'react';
// import jQuery from 'jquery';


class BeWise_Header extends React.Component {

    constructor(props) {
        super(props);
        //const { history } = this.props;
        this.state = {
            logged_user_name: ''
        };
    }
  
  logoutSess(e) {
    localStorage.clear();
    setTimeout(function () {
      window.location = '/login';
    }, 1000);
  }


    componentDidMount() {
  
        // console.log('user data', this.state.auth_data)
    }

    render() {
        return (
              
            <React.Fragment>

                <nav class="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row c">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-space-between">
          <a class="navbar-brand brand-logo"><img src="/images/bewiseLogo.png" alt="BeWise"/></a>
          <a class="navbar-brand brand-logo-mini" ><img src="/images/bewise-logo-mini.png" alt="BeWise"/></a>
          <button class="navbar-toggler navbar-toggler align-self-center d-none d-lg-flex" type="button" data-toggle="minimize">
            <span class="typcn typcn-th-menu"></span>
          </button>
        </div>
        <div class="navbar-menu-wrapper d-flex align-items-center justify-content-end">
          
          <ul class="navbar-nav navbar-nav-right">
            { /* <li class="nav-item d-none d-lg-flex  mr-2">
              <a class="nav-link" href="#">
                Help
              </a>
            </li>
            <li class="nav-item dropdown d-flex">
              <a class="nav-link count-indicator dropdown-toggle d-flex justify-content-center align-items-center" id="messageDropdown" href="#" data-toggle="dropdown">
                <i class="typcn typcn-message-typing"></i>
                <span class="count bg-success">0</span>
              </a>
              <div class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list" aria-labelledby="messageDropdown">
                <p class="mb-0 font-weight-normal float-left dropdown-header">Messages</p>
                 
                 
                 
              </div>
            </li> */}
            { /* <li class="nav-item dropdown  d-flex">
              <a class="nav-link count-indicator dropdown-toggle d-flex align-items-center justify-content-center" id="notificationDropdown" href="#" data-toggle="dropdown">
                <i class="typcn typcn-bell mr-0"></i>
                <span class="count bg-danger">0</span>
              </a>
              <div class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list" aria-labelledby="notificationDropdown">
                <p class="mb-0 font-weight-normal float-left dropdown-header">Notifications</p>
                
                
              </div>
            </li> */} 
            <li class="nav-item nav-profile dropdown">
              <a class="nav-link dropdown-toggle  pl-0 pr-0" href="#" data-toggle="dropdown" id="profileDropdown">
                <i class="typcn typcn-user-outline mr-0"></i>
                <span class="nav-profile-name">{this.state.nickname}</span>
              </a>
              <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="profileDropdown">
                { /* <a class="dropdown-item">
                <i class="typcn typcn-cog text-primary"></i>
                Settings
                </a> */}
                <a class="dropdown-item" onClick={() => this.logoutSess()}>
                <i class="typcn typcn-power text-primary"></i>
                Logout
                </a>
              </div>
            </li>
          </ul>
          <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
            <span class="typcn typcn-th-menu"></span>
          </button>
        </div>
      </nav>


            </React.Fragment>

        )
    }
}
export default BeWise_Header;


// WEBPACK FOOTER //
// ./src/components/bewise/header.jsx